// apps/spa/src/routes/RoleRequired.tsx
// Locked AUTH-03 named-blocking-page copy in React-route form.
// Phase 2 already serves the same content from Pages Functions on hard 403;
// this React route is reachable when api.ts intercepts a runtime ROLE_REQUIRED
// response and navigates here.
//
// LOCKED: heading literal "BASTN Officer role required" — do not paraphrase.

import { AmbientBackground } from '@/components/visual/AmbientBackground';

export function RoleRequired() {
  return (
    <div className="relative min-h-screen text-foreground flex items-center justify-center px-4">
      <AmbientBackground variant="full" />
      <div className="glass w-full max-w-lg p-8">
        <h1 className="font-display text-3xl text-primary">
          BASTN Officer role required
        </h1>
        <p className="mt-4 text-sm text-foreground">
          You completed Discord login, but your account does not have the BASTN
          Officer role required to use this tool. If you believe this is a
          mistake, contact a server admin.
        </p>
        <a
          href="/api/auth/start"
          className="mt-6 inline-flex items-center justify-center rounded-md border border-primary bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Try a different account
        </a>
      </div>
    </div>
  );
}
